import React from 'react';
import sc from 'styled-components';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    size?: number | string;
    color?: string;
    animationDuration?: number;
    isUp?: boolean;
}

const StyledSVG = sc.svg<{$duration: number}>`
    transition: transform ${({$duration}) => $duration}s ease-in-out;
    
    path {
        transition: 
            opacity ${({$duration}) => $duration / 2}s ease-in-out,
            transform ${({$duration}) => $duration / 2}s ease-in-out;
    }
`;

const HorizontalPath = sc.path<{$show: boolean; $duration: number}>`
    opacity: ${({$show}) => ($show ? 1 : 0)};
    transition: opacity ${({$duration}) => $duration / 4}s ease-in-out;
`;

const DirectionalPath = sc.path<{$show: boolean; $duration: number}>`
    opacity: ${({$show}) => ($show ? 1 : 0)};
    transition: opacity ${({$duration}) => $duration / 2}s ease-in-out;
`;

const ChevronUpAndDownIcon: React.FC<IconProps> = ({
	size = 24,
	color = '#001B74',
	animationDuration = 0.2,
	isUp = false,
	...props
}): React.JSX.Element => {
	return (
		<StyledSVG
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			$duration={animationDuration}
			{...props}
		>
			{/* Horizontal line - shows during transition */}
			<HorizontalPath
				d="M19 12L12 12L5 12"
				stroke={color}
				strokeWidth="2.55"
				strokeLinecap="round"
				$show={false} // You can control this for transition effect
				$duration={animationDuration}
			/>
            
			{/* Down chevron */}
			<DirectionalPath
				d="M5 12L11.8571 18.8571L18.7143 12"
				stroke={color}
				strokeWidth="2.55"
				strokeLinecap="round"
				$show={!isUp}
				$duration={animationDuration}
			/>
            
			{/* Up chevron */}
			<DirectionalPath
				d="M18.7143 11.8571L11.8572 4.99997L5.00001 11.8571"
				stroke={color}
				strokeWidth="2.55"
				strokeLinecap="round"
				$show={isUp}
				$duration={animationDuration}
			/>
		</StyledSVG>
	);
};

export default ChevronUpAndDownIcon;